import { render, staticRenderFns } from "./main-menu-button.component.vue?vue&type=template&id=d7af1db8&"
import script from "./main-menu-button.component.vue?vue&type=script&lang=js&"
export * from "./main-menu-button.component.vue?vue&type=script&lang=js&"
import style0 from "./main-menu-button.component.vue?vue&type=style&index=0&id=d7af1db8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports